export default __webpack_public_path__ + "static/media/Snow.116ddd70.png";